<template>
    <div class="langs">
        <a :class="{selected: language==='uz'}" @click="changeLang('uz')">
            UZ
        </a>
        <a :class="{selected: language==='ru'}" @click="changeLang('ru')">
            RU
        </a>
        <a :class="{selected: language==='en'}" @click="changeLang('en')">
            EN
        </a>
    </div>
</template>

<script>
    export default {
        name: "LangSection",
        methods: {
            changeLang(lang) {
                this.$store.commit('changeCurrentLanguage', lang);
            }
        },
        computed: {
            language() {
                return this.$store.state.currentLang;
            }
        }
    }
</script>


<style lang="scss">
    aside {
        &.active {
            .langs {
                display: none;
            }
        }

        .langs {
            & {
                text-align: center;
                margin: 10px;
            }

            a {
                & {
                    font-size: 11px;
                    cursor: pointer;
                    background: rgb(32, 35, 70);
                    margin: 0;
                    padding: 0 20px;
                    box-shadow: 0 0 2px;
                }

                &.selected {
                    font-weight: bold;
                    cursor: default;
                    background: white;
                    color: #202346;
                }
            }
        }
    }
</style>
